<ng-template #content>
  @if (ctx; as ctx) {
    <div class="modal-header">
      <h5 class="modal-title">
        <i class="fa fa-exclamation-triangle text-danger me-2"></i>
        Failing test details
      </h5>
      <button type="button" class="btn-close" aria-label="Close" (click)="ctx.onClose(true)"></button>
    </div>
    <div class="modal-body">
      @if (ctx.getFailedTest(); as failedTest) {
        <div class="test-failure-info mb-4">
          <h6 class="test-title">Add a comment for {{ failedTest.title }}</h6>
          <p class="test-instruction text-muted">Explain why this test failed and how to fix it</p>
        </div>
      }
      <div class="failure-comment-section mb-4">
        <label class="form-label fw-bold">Description</label>
        <textarea class="form-control failure-comment-textarea"
          [formControl]="ctx.getFailureCommentControl()"
          placeholder="Enter detailed explanation about the test failure..." rows="6">
        </textarea>
      </div>
      <div class="failure-evidence-section">
        <h6 class="evidence-title mb-3">Evidence</h6>
        <div class="evidence-upload-area mt-2">
          <input type="file" #failureFileInput id="failure-evidence-file"
            (change)="ctx.onFileSelected($event)" style="display: none;">
          <div class="file-upload-wrapper mb-3">
            <button type="button" class="btn btn-outline-primary w-100"
              [disabled]="!ctx.canUploadFailureFile()"
              (click)="ctx.onTriggerFileInput()">
              <i class="fa fa-file me-2"></i>
              Choose File
            </button>
            <div class="file-status-text mt-3">
              @if (ctx.getFailureEvidenceFiles().length === 0) {
                <span>No file selected</span>
              } @else {
                {{ ctx.getFailureEvidenceFiles().length }} files selected
              }
            </div>
          </div>
          @if (ctx.getFailureEvidenceFiles().length > 0) {
            <div class="uploaded-failure-files">
              @for (file of ctx.getFailureEvidenceFiles(); track file; let fileIndex = $index) {
                <div
                  class="failure-file-item d-flex align-items-center justify-content-between mb-2">
                  <span class="file-name">{{ file.name }}</span>
                  <button type="button" class="btn btn-sm btn-outline-danger"
                    (click)="ctx.onRemoveFailureFile(fileIndex)">
                    <i class="fa fa-times"></i>
                  </button>
                </div>
              }
            </div>
          }
          @if (ctx.getFailureExistingEvidenceFiles().length > 0) {
            <div class="uploaded-failure-files existing-failure-files mt-3"
              >
              <label class="fw-bold">Uploaded files</label>
              @for (file of ctx.getFailureExistingEvidenceFiles(); track file; let idx = $index) {
                <div
                  class="failure-file-item d-flex align-items-center justify-content-between mb-2">
                  <span class="file-name">{{ file.fileName }}</span>
                  <div class="file-actions">
                    @if (file.url) {
                      <button type="button" class="btn btn-sm btn-outline-primary"
                        (click)="ctx.onDownloadFailureFile(file)">
                        <i class="fa fa-download"></i>
                      </button>
                    }
                    @if (ctx.canDeleteFiles) {
                      <button type="button" class="btn btn-sm btn-outline-danger ms-1"
                        (click)="ctx.onRemoveExistingFailureFile(idx)">
                        <i class="fa fa-times"></i>
                      </button>
                    }
                  </div>
                </div>
              }
            </div>
          }
        </div>
      </div>
    </div>
    <div class="modal-footer d-flex justify-content-between align-items-center">
      <button type="button" class="btn btn-secondary" (click)="ctx.onClose(true)">Back</button>
      @if (ctx.canCloneIssue()) {
        <button type="button" class="btn btn-outline-primary clone-issue-btn" (click)="ctx.onCloneIssue()">
          <i class="fa fa-clone me-2"></i>
          Clone Issue
        </button>
      }
      <button type="button" class="btn btn-primary" [disabled]="!ctx.isFailureModalValid()"
        (click)="ctx.onConfirm()">
        Confirm
      </button>
    </div>
  }
</ng-template>
